export default __webpack_public_path__ + "static/media/security_double_sign.e5d09e3c.svg";